import { z } from 'zod';

export interface UsersPageDataRow {
  id: number;
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  father_name: string;
  phone_number: string | null;
  role: string;
  dob: string | null;
  experience: number | null;
  avatar: string;
  company_name: string | null;
}

const baseUserSchema = z.object({
  email: z.string().min(1, { message: 'Required field' }),
  first_name: z.string().min(3, { message: 'Required field' }),
  last_name: z.string().min(3, { message: 'Required field' }),
  father_name: z.string().optional(),
  phone_number: z.string().optional(),
  role: z.string().min(1, { message: 'Required field' }),
  dob: z.string().optional(),
  experience: z.number().optional(),
  avatar: z.union([z.string(), z.instanceof(File)]),
});

export const userCreateSchema = baseUserSchema
  .extend({
    password: z.string().min(5, { message: 'Password must be at least 5 characters' }),
    password_check: z.string().min(5, { message: 'Password must be at least 5 characters' }),
  })
  .refine(d => d.password === d.password_check, {
    message: 'Passwords do not match',
    path: ['password_check'],
  });

export const userUpdateSchema = baseUserSchema
  .extend({
    // allow missing OR empty on edit
    password: z.string().optional().or(z.literal('')),
    password_check: z.string().optional().or(z.literal('')),
  })
  .refine(
    d => {
      // if one is provided, require both and match
      if (d.password || d.password_check) return d.password === d.password_check;
      return true;
    },
    {
      message: 'Passwords do not match',
      path: ['password_check'],
    },
  );

export type UserCreateFormValues = z.infer<typeof userCreateSchema>;
export type UserUpdateFormValues = z.infer<typeof userUpdateSchema>;
